let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("11tIB"), load("aj3n8"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("1Y6tF")]).then(() => parcelRequire('b3HrA'));